export const SHOPIFY_SIGNIN_KEY='m5m_shopify_signin_v1';
export const signinLanding=search=>new URLSearchParams(search||'').has('shopifySignin');
export function normalizeSigninShop(value){
 const shop=String(value||'').trim().toLowerCase().replace(/^https:\/\//,'').replace(/\/$/,'');
 const domain=shop.includes('.')?shop:shop+'.myshopify.com';
 return /^[a-z0-9][a-z0-9-]*\.myshopify\.com$/.test(domain)?domain:null;
}
export function signinDestination(path){return ['/home','/performance','/leads','/magnets','/settings/integrations','/settings/billing'].includes(path)?path:'/home';}
export function readSigninAttempt(storage=sessionStorage,now=Date.now()){
 try{const item=JSON.parse(storage.getItem(SHOPIFY_SIGNIN_KEY));return item&&/^[a-f0-9-]{36}$/.test(item.id)&&/^[a-f0-9]{64}$/.test(item.verifier)&&item.expiresAt>now&&normalizeSigninShop(item.shop)===item.shop?item:null;}catch{return null;}
}
export async function makeSigninProof(cryptoImpl=crypto){
 const verifier=Array.from(cryptoImpl.getRandomValues(new Uint8Array(32)),b=>b.toString(16).padStart(2,'0')).join('');
 const digest=await cryptoImpl.subtle.digest('SHA-256',new TextEncoder().encode(verifier));
 return {verifier,challenge:Array.from(new Uint8Array(digest),b=>b.toString(16).padStart(2,'0')).join('')};
}
export const signinMessages={
 shopify_signin_unavailable:'Shopify sign-in is not available yet. Use your Magnet email and password.',
 shopify_signin_expired:'This sign-in expired or was already used. Start again to get a new sign-in window.',
 shopify_signin_store:'Enter your store’s myshopify.com address.',
 shopify_signin_connection:'Connect this store to a Magnet workspace from the Shopify app first, then try again.',
 shopify_signin_access:'This Shopify account no longer has access to the linked Magnet workspace. Sign in with your Magnet account to review the connection.',
 shopify_signin_reauthenticate:'Sign in with your Magnet password or passkey again before linking Shopify sign-in.',
 shopify_signin_already_linked:'Shopify sign-in is already linked. Use the linked account, or remove Shopify sign-in from that account before linking another.',
 shopify_signin_rate:'Too many attempts. Wait a minute, then try again.'
};
